import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["show"]

  showSummary(event) {
    const button = event.currentTarget;
    const container = button.closest('.report-per-patient');
    const showTarget = container.querySelector('.patient-report__summary');
    showTarget.classList.toggle("show");
  }
}
